import { Http, Url } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getListStatus({ commit }) {
    commit('toggleLoadingListStatus', true);
    return Http.get('api/v1/tracking_event_statuses')
      .then((res) => {
        commit('toggleLoadingListStatus', false);
        commit('setListStatus', res.data.content);
        return res;
      })
      .catch((err) => {
        commit('toggleLoadingListStatus', false);
        throw err;
      });
  },
  getListSubStatus({ commit }, status) {
    commit('toggleLoadingListSubStatus', true);

    const pathParams = [
      status,
      'substatuses',
    ];
    return Http.get(Url.toQueryString('api/v1/tracking_event_statuses', null, pathParams))
      .then((res) => {
        commit('toggleLoadingListSubStatus', false);
        commit('setListSubStatus', res.data.content);
        return res;
      })
      .catch((err) => {
        commit('toggleLoadingListSubStatus', false);
        throw err;
      });
  },
  getAllLogs({ commit }, config = {}) {
    commit('toggleLoading', true);

    const {
      filters = {},
    } = config;

    const {
      typeSpecific,
      valueSpecific,
      dateRange = {},
      ...newFilters
    } = filters;

    const {
      end,
      start,
    } = dateRange;


    if (typeSpecific && valueSpecific) {
      Object.assign(newFilters, {
        [typeSpecific]: valueSpecific,
      });
    }

    const params = Object.assign({}, newFilters, {
      end: `"${end}"`,
      start: `"${start}"`,
      limit: 500,
      page: 1,
    });

    return Http.get(Url.toQueryString('api/v1/tracking_events', params))
      .then((res) => {
        const {
          data = {},
        } = res;
        const {
          content,
        } = data || {};
        const {
          content: items = [],
          total,
        } = content || {};
        const eventsList = [];

        items.forEach((item) => {
          const {
            logistic_provider_id,
            request_info,
            hashcode,
            events,
          } = item;

          const {
            date,
            identifiers,
          } = request_info;

          const {
            shipment_order_number,
            invoice_number,
            invoice_key,
          } = identifiers;

          events.forEach((event) => {
            const {
              original_code,
              history,
                } = event;

            const [historyUnit] = history;
            const {
                status,
                substatus,
                message,
                external_code,
              } = historyUnit;

            eventsList.push({
              request_hash: hashcode,
              logistic_provider_id,
              date,
              shipment_order_number,
              invoice_number,
              invoice_key,
              original_code,
              status,
              substatus,
              message,
              external_code,
            });
          });
        });

        const logs = {
          total,
          events: eventsList,
        };

        commit('toggleLoading', false);
        commit('setLogs', logs);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  exportAllLogs({ commit }, config) {
    commit('toggleLoadingExporting', true);

    const {
      filters = {},
      pagination = {},
    } = config;

    const {
      typeSpecific,
      valueSpecific,
      dateRange,
      ...newFilters
    } = filters;

    if (typeSpecific && valueSpecific) {
      Object.assign(newFilters, {
        [typeSpecific]: valueSpecific,
      });
    }

    return Http.get(Url.toQueryString('api/v1/report/event_logs', Object.assign({}, newFilters, {
      ...dateRange,
      ...Object.assign(pagination, {
        page: 1,
        limit: 9999,
      }),
    })))
      .then((res) => {
        commit('toggleLoadingExporting', false);
        return res;
      })
      .catch((err) => {
        commit('toggleLoadingExporting', false);
        throw err;
      });
  },
  getEvent({ commit }, { hash, eventCode }) {
    commit('toggleLoading', true);
    return Http.get(Url.toQueryString('api/v1/tracking_events', { eventCode }, [hash]))
      .then((res) => {
        const {
          data,
        } = res;
        const {
          content,
        } = data || {};
        commit('toggleLoading', false);
        commit('setEvent', content);
        return res;
      })
      .catch((err) => {
        commit('toggleLoading', false);
        throw err;
      });
  },
  getLote({ commit, state }, hash) {
    commit('toggleLoading', true);

    return Promise.all([
      Http.get(Url.toQueryString('api/v1/tracking_events', { hash, page: 1, limit: 500 })),
      Http.get(Url.toQueryString('api/v1/tracking/event_monitorings', { hash }))
        .catch(() => Promise.resolve()),
    ])
      .then((res) => {
        const [resEvents = {}, resHistory = {}] = res;
        let historyList = [];
        const eventsList = [];

        const {
          data,
        } = resEvents;

        const {
          content,
        } = data;

        const {
          content: items,
          total,
        } = content;

        if (resEvents.data && resEvents.data.content.content) {
          items.forEach((item) => {
            const {
                  logistic_provider_id,
                  request_info,
                  hashcode,
                  events,
                  origin,
                  subflow,
                } = item;


            const {
                  date,
                  identifiers,
                } = request_info;

            const {
                  shipment_order_number,
                  invoice_number,
                  invoice_key,
                } = identifiers;

            events.forEach((event) => {
              const {
                original_code,
                history,
              } = event;

              const [historyUnit] = history;
              const {
                status,
                substatus,
                message,
                external_code,
              } = historyUnit;

              eventsList.push({
                request_hash: hashcode,
                logistic_provider_id,
                date,
                shipment_order_number,
                invoice_number,
                invoice_key,
                original_code,
                status,
                substatus,
                message,
                external_code,
                origin,
                subflow,
              });
            });
          });
        }
        if (resHistory.data && resHistory.data.content) {
          historyList = [resHistory.data.content];
        }
        console.log('eventsList', eventsList); //eslint-disable-line
        commit('toggleLoading', false);
        commit('setLote', {
          hash,
          eventsList,
          total,
          historyList,
        });
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  reprocessLote({ commit, state }) {
    const { hash } = state.lote;
    commit('toggleLoadingReprocess', true);

    return Http.post('api/v1/tracking/events', { resend_hash: hash })
      .then((res) => {
        commit('toggleLoadingReprocess', false);
        ScToast.success('Lote será reprocessado');
        return res;
      })
      .catch((err) => {
        commit('toggleLoadingReprocess', false);
        throw err;
      });
  },
  getLotePayload({ commit, state }) {
    commit('toggleLoadingPayload', true);

    const pathParams = [
      state.lote.hash,
      'payload',
    ];

    return Http.get(Url.toQueryString('api/v1/tracking/event_monitorings', null, pathParams))
      .then((res) => {
        commit('toggleLoadingPayload', false);
        return res.data.content;
      })
      .catch((err) => {
        commit('toggleLoadingPayload', false);
        ScToast.danger('Dado não encontrado');
        throw err;
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/store/actions.js